import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicStorageModule } from '@ionic/storage'; 

import { Insomnia } from '@ionic-native/insomnia';

import { SuperTabsModule } from 'ionic2-super-tabs';

import { MyApp } from './app.component';
import { ServicesProvider } from '../providers/services/services';
import { SimpleAlertProvider } from '../providers/simple-alert/simple-alert';
import { DataProvider } from '../providers/data/data';
import { WebsocketService } from '../providers/websocket/websocket';

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [    
      BrowserModule,
      IonicModule.forRoot(MyApp,{
            scrollAssist: true, 
            autoFocusAssist: 'delay'
        }, 
{
  links: [
    { loadChildren: '../pages/account/account.module#AccountPageModule', name: 'AccountPage', segment: 'account', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/chat/chat.module#ChatPageModule', name: 'ChatPage', segment: 'chat', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/games/games.module#GamesPageModule', name: 'GamesPage', segment: 'games', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/gatchas/gatchas.module#GatchasPageModule', name: 'GatchasPage', segment: 'gatchas', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/home/home.module#HomePageModule', name: 'HomePage', segment: 'home', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/login/login.module#LoginPageModule', name: 'LoginPage', segment: 'login', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/machine/machine.module#MachinePageModule', name: 'MachinePage', segment: 'machine', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/profile/profile.module#ProfilePageModule', name: 'ProfilePage', segment: 'profile', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/settings/settings.module#SettingsPageModule', name: 'SettingsPage', segment: 'settings', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/shop/shop.module#ShopPageModule', name: 'ShopPage', segment: 'shop', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/signin/signin.module#SigninPageModule', name: 'SigninPage', segment: 'signin', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/singleGame/singleGame.module#SingleGamePageModule', name: 'SingleGamePage', segment: 'singleGame', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/splash/splash.module#SplashPageModule', name: 'SplashPage', segment: 'splash', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/trophies/trophies.module#TrophiesPageModule', name: 'TrophiesPage', segment: 'trophies', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/variant/variant.module#VariantPageModule', name: 'VariantPage', segment: 'variant', priority: 'low', defaultHistory: [] }
  ]
}),
      SuperTabsModule.forRoot(),
      HttpModule, 
      IonicStorageModule.forRoot() 
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ServicesProvider,
    SimpleAlertProvider,
    DataProvider,
    WebsocketService,
	Insomnia
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts